import { Component, OnInit, OnDestroy} from '@angular/core';
import { Router, ROUTER_DIRECTIVES, ActivatedRoute } from '@angular/router';
import { IOperation } from '../airport-interfaces';
import { TabViewModule } from 'primeng/primeng';
import { TabView } from 'primeng/primeng';
import { TabPanel } from 'primeng/primeng';

import { AirportService } from '../airport.service';
import { IScenario, ScenarioService } from '../../scenario-activities/scenario.service';

import { UserSession } from '../../shared/user-session';
import { UserInfoService } from '../../shared/user-info.service';

import { Button } from 'primeng/primeng';
import { Dialog } from 'primeng/primeng';
import * as _ from 'lodash';
import {Messages} from 'primeng/primeng';

import { OperationGridComponent } from './operation-grid.component';


@Component({
    template: require('./operations-list.component.html'),
    //styles: [require('../airport.css')],
    styles: [require('../../styles/faa_styles.css')],
    directives: [ROUTER_DIRECTIVES, Button, TabView, TabPanel, OperationGridComponent, Dialog]
})

export class OperationsListComponent implements OnInit, OnDestroy{
    pageTitle: string;
    errorMessage: string;


    private sub: any;    

    //think I need current not all
    currentScenario: IScenario;
    allScenarios: IScenario[];

    displayNotes: boolean = false;
    scenarioNote: string;
    notesTitle: string;

    isScenarioOwner: boolean = false;

    canEdit: boolean = false;

    tableName: string;
    allOperations: IOperation[];
    locId: string;
    airportName: string;
    displayAll: boolean = false;
    msgs: Messages[]=[];

    constructor(private route: ActivatedRoute,
                private router: Router,
                private _airportService: AirportService,
                private _scenarioService: ScenarioService, 
                private User: UserSession, 
                private _userInfoService: UserInfoService) {
    }


    ngOnInit(): void{
        this.sub = this.route.params.subscribe(
            params => {
                this.tableName = params['tableName'];
                this.locId = params['locId'];
                this.airportName = params['airportName'];
                this.displayAll = params['displayAll'];
                
                this._airportService.getOperations()
                    .subscribe(
                        operations => this.allOperations = operations,
                        error => this.errorMessage = <any>error);
            }
        );

        this._scenarioService.getScenarios(this.User.getSession()['id'])
            .subscribe(
                scenarios => this.allScenarios = scenarios,
                error => this.errorMessage = <any>error,
                () => {
                    this.setScenarioHeader(this.User.getSession().scenarioId);
                }
            );

        this._userInfoService.isScenarioOwner(this.User.getSession()['id'], this.User.getSession().scenarioId).subscribe(
            success =>{ this.isScenarioOwner = success.isOwner; 
                if(this.isScenarioOwner == false && this.User.isAdmin == false){
                    //console.log("this.isScenarioOwner == false " + (this.isScenarioOwner == false));
                    this.msgs = [];
                    this.msgs.push({severity:'warn', summary:'Warn Message', detail:'We\'re sorry,  your access level does not permit you to view this page. Contact the TAF administrator to change your access privileges.'});
                }
            },
            error => this.errorMessage = <any>error
        );
    }

    ngOnDestroy() {
        this.sub.unsubscribe();
    }

    private setScenarioHeader(scenarioId: number):void {
        let foundScenarios:IScenario[] = this.allScenarios.filter(function(scenario){
            return scenario.id === scenarioId;
        });
        if(foundScenarios.length > 0){
            this.currentScenario = foundScenarios[0];
        }
    }

    showNotes() {

        if(this.isScenarioOwner || this.User.getSession().isAdmin){
            this.notesTitle = "Edit Scenario Notes";
        }
        else{
            this.notesTitle = "View Scenario Notes";
        }

        this._airportService.getScenarioNotes(this.locId, this.User.getSession().scenarioId)
                .subscribe(
                    success => {
                        if(!_.isEmpty(success)){
                            this.scenarioNote = success;
                        }
                        this.displayNotes = true;
                    },
                    error => this.errorMessage = "An error occured while attempting to retrieve notes."
                );
    }

    saveNotes() { 
        this._airportService.updateScenarioNotes(this.locId, this.User.getSession().scenarioId, this.scenarioNote)
                .subscribe(
                    success => {},
                    error => {
                        this.errorMessage = "An error occured while attempting to save your note.";
                        this.displayNotes = false;
                    },
                    () => this.displayNotes = false
                );
    }


    onTabChange(event: any) {

        let params = {
            locId: this.locId,
            airportName: this.airportName
        }

        this.router.navigate([`/operations-list/${this.allOperations[event.index].tableName}`, params]);
    }

    back(){
        this.router.navigate([`/airports/${this.locId}`]);
    }

    graphData(){
        let params = {
            locId: this.locId,
            airportName: this.airportName
        }

        this.router.navigate([`/operations-graph/${this.tableName}`, params]);
    }

    print(){
        //console.log("printing");
        document.getElementById("customButtons").style.visibility="hidden";
        //document.getElementById("customPanelBody").style.width = "1000px";
        document.getElementById("taf-header").style.visibility="hidden";
        document.getElementById("taf-footer").style.visibility="hidden";
        window.print();
        document.getElementById("customButtons").style.visibility="visible";
        //document.getElementById("customPanelBody").style.width = "1000px";
        document.getElementById("taf-header").style.visibility="visible";
        document.getElementById("taf-footer").style.visibility="visible";
    }

}



/** WEBPACK FOOTER **
 ** ./app/airports/Operations-lists/operations-list.component.ts
 **/